import { forwardRef, useRef } from 'react';
import { usePM2DisplayContext } from '@pm2/store';
import { ComponentDisplayContext } from '@utils/component-framework';
import { assertRefObject } from '@utils/react';
import { wrapper } from './comp.root.style.js';
import { Router } from './comp.router.js';
import { jsx } from 'react/jsx-runtime';

const PM2ImageHotspotsComponent = /*#__PURE__*/forwardRef(function IGuideComponent(props, externalRef) {
  const internalRef = useRef(null);
  const rootRef = externalRef ?? internalRef;
  assertRefObject(rootRef);
  const {
    inLightbox
  } = usePM2DisplayContext();
  return /*#__PURE__*/jsx(ComponentDisplayContext.Provider, {
    value: inLightbox ? "lightbox" : "embedded",
    children: /*#__PURE__*/jsx("article", {
      ref: rootRef,
      className: wrapper,
      children: /*#__PURE__*/jsx(Router, {
        ...props,
        rootRef: rootRef
      })
    })
  });
});

export { PM2ImageHotspotsComponent };
//# sourceMappingURL=comp.root.js.map
